import { useQuery } from '@tanstack/react-query';
import { teamApi } from '@/api';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent } from '@/components/ui/card';
import { getTeamIcon } from '@/lib/team-icons';

export function TeamPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['team'],
    queryFn: teamApi.list,
    staleTime: 60_000,
  });

  return (
    <div className="mx-auto max-w-4xl px-6 lg:px-12 py-12">
      <h1 className="text-3xl md:text-4xl font-extrabold text-eol-white">Команда сервера</h1>
      <p className="mt-3 text-eol-desc">
        Эти ребята делают так, чтобы EOL работал круглосуточно.
      </p>

      {isLoading ? (
        <p className="mt-8 text-eol-desc">Загрузка…</p>
      ) : !data || data.length === 0 ? (
        <p className="mt-8 text-eol-desc">Команда ещё не заполнена.</p>
      ) : (
        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {data.map((m) => {
            const Icon = getTeamIcon(m.icon);
            return (
              <Card key={m.id}>
                <CardContent className="pt-6 text-center">
                  {m.avatarUrl ? (
                    <img
                      src={m.avatarUrl}
                      alt={m.name}
                      className="h-20 w-20 mx-auto rounded-full object-cover mb-3 ring-2 ring-eol-pink/20"
                    />
                  ) : (
                    <div className="h-20 w-20 mx-auto rounded-full bg-gradient-to-br from-eol-pink/30 to-transparent grid place-items-center mb-3">
                      <Icon className="h-9 w-9" style={{ color: m.color }} />
                    </div>
                  )}
                  <h3 className="font-bold text-eol-white text-lg">{m.name}</h3>
                  <Badge className="mt-2">{m.role}</Badge>
                  {m.description && (
                    <p className="mt-3 text-sm text-eol-desc">{m.description}</p>
                  )}
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
